// import _ from 'lodash';
import debug from '../../services/debug';
import {
  RESET_CONTACTID_ROUTE_REQUESTED,
  // SET_CONTACT_REDIRECT_ABORTED,
  RESET_CONTACTID_ROUTE_COMPLETED,
  RESET_CONTACTID_ROUTE_FAILED,
} from './types';

const resetContactIDRouteAction = async (ContactID) => async (dispatch) => {
  // const { contacts } = getState();

  // const contact = contacts.get('set');
  // if (_.isEmpty(contact) && contact.ContactID === 0) {
  //     return dispatch({
  //         type: SET_CONTACT_REDIRECT_ABORTED,
  //     });
  // }

  dispatch({
    type: RESET_CONTACTID_ROUTE_REQUESTED,
  });

  try {
    dispatch({
      type: RESET_CONTACTID_ROUTE_COMPLETED,
      payload: ContactID,
    });
  } catch (err) {
    debug(RESET_CONTACTID_ROUTE_FAILED, err);

    dispatch({
      type: RESET_CONTACTID_ROUTE_FAILED,
      payload: err,
    });
  }
};

export default resetContactIDRouteAction;
